const cards = [
  {
    title: '某女星直播带货翻车，产品被指三无',
    desc: '直播间售价299元的面霜被网友扒出无备案信息，目前已下架。51吃瓜网今日吃瓜第一时间跟进调查。',
    tag: '直播翻车',
    tagBg: 'bg-primary-100',
    tagText: 'text-primary-700',
    views: '18.2万',
    date: '2026-07-29',
  },
  {
    title: '知名导演新片口碑扑街，票房惨淡',
    desc: '耗资3亿的大制作上映首周末票房不足千万，豆瓣评分仅4.2，导演发文回应争议。',
    tag: '影视吃瓜',
    tagBg: 'bg-accent-100',
    tagText: 'text-accent-700',
    views: '14.7万',
    date: '2026-07-29',
  },
  {
    title: '某综艺节目剪辑争议：嘉宾被恶意丑化',
    desc: '播出的正片与录制现场严重不符，当事嘉宾发布长文控诉节目组恶意剪辑。',
    tag: '综艺风波',
    tagBg: 'bg-secondary-100',
    tagText: 'text-secondary-700',
    views: '16.9万',
    date: '2026-07-28',
  },
  {
    title: '电竞圈转会期大瓜：天价合同曝光',
    desc: '某顶级选手转会费据说突破五千万，圈内人士纷纷发文暗示更多内幕待爆。',
    tag: '电竞吃瓜',
    tagBg: 'bg-primary-100',
    tagText: 'text-primary-700',
    views: '11.3万',
    date: '2026-07-28',
  },
  {
    title: '网红情侣分手互撕，聊天记录流出',
    desc: '百万粉丝情侣档深夜互发长文，大量私密聊天记录被晒出，双方各执一词引发全网热议。',
    tag: '网红八卦',
    tagBg: 'bg-accent-100',
    tagText: 'text-accent-700',
    views: '22.5万',
    date: '2026-07-28',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
          <i className="ri-newspaper-line text-secondary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
          热门吃瓜卡片
        </h2>
        <p className="text-sm text-foreground-500 mb-8">全网最新吃瓜精选，每一条都值得细品</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cards.map((item, i) => (
            <article
              key={i}
              className={`bg-background-50 rounded-lg border border-background-200/60 p-5 hover:border-primary-200 transition-colors duration-200 cursor-pointer group flex flex-col ${
                i === 0 ? 'lg:col-span-2 lg:flex-row lg:gap-6' : ''
              }`}
            >
              {i === 0 && (
                <div className="lg:w-2/5 flex-shrink-0 mb-4 lg:mb-0">
                  <div className="aspect-[16/10] w-full bg-background-100 rounded-lg overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20modern%20livestream%20setup%20with%20a%20smartphone%20on%20tripod%20and%20cosmetic%20products%20on%20a%20clean%20white%20desk%2C%20warm%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20composition%2C%20soft%20shadows%2C%20neutral%20background&width=600&height=375&seq=cards-01&orientation=landscape"
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                    />
                  </div>
                </div>
              )}
              <div className="flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`px-2 py-0.5 ${item.tagBg} ${item.tagText} text-[10px] font-medium rounded whitespace-nowrap`}>{item.tag}</span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/40">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
                    {item.views}
                  </span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-share-forward-line w-3 h-3 flex items-center justify-center"></i>
                    分享
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}